
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro/news/[slug]",
      function () {
        return require("private-next-pages/pro/news/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro/news/[slug]"])
      });
    }
  